module.exports = __webpack_public_path__ + "static/img/wap_banner_2.97a01d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/mExtensionPage/wap_banner_2.png
// module id = tGL0
// module chunks = 0